import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

interface Product {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
  amazonLink: string;
}

const products: Product[] = [
  {
    id: 1,
    name: "Philips Norelco Multigroomer All-in-One Trimmer",
    description: "The #1 best-selling trimmer on Amazon. It comes with 23 attachments for beard, head, body, and nose trimming.",
    price: "$29.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/6576e0acd58187524f273a4fac516d9a.png",
    amazonLink: "https://amzn.to/45MuRI1"
  },
  {
    id: 2,
    name: "Carhartt Men's Knit Cuffed Beanie",
    description: "A fashion staple that transcends workwear. It is durable, warm, and comes in dozens of colors.",
    price: "$14.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/05d4499fe9c3306838a490610491c083.png",
    amazonLink: "https://amzn.to/49W9kPw"
  },
  {
    id: 3,
    name: "Kindle Paperwhite (16 GB)",
    description: "The latest model with a larger display and warm light is the top choice for reading on the go.",
    price: "$149.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/b062dc388c4f6229023b6e581ce28f46.png",
    amazonLink: "https://amzn.to/45K6jiQ"
  },
  {
    id: 4,
    name: "Bose SoundLink Micro Bluetooth Speaker",
    description: "A tiny, rugged, waterproof speaker with surprisingly huge bass. It features a tear-resistant strap to attach to bikes or backpacks.",
    price: "$119.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/5af491ffff374a0363b0a76709d0e1d0.png",
    amazonLink: "https://amzn.to/4qp3AUr"
  },
  {
    id: 5,
    name: "Under Armour Men's Tech 6-inch Boxerjock",
    description: "Widely reviewed as the most comfortable underwear for men, featuring sweat-wicking fabric and a 'no-ride-up' fit.",
    price: "$24.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/ef769810c578a54a48591d4b13949f2e.png",
    amazonLink: "https://amzn.to/49WePxM"
  },
  {
    id: 6,
    name: "Toloco Massage Gun",
    description: "A high-powered percussion massager that rivals the expensive brands. It's a top seller for post-workout recovery.",
    price: "$89.99",
    image: "https://public.readdy.ai/ai/img_res/85ef7772ac97420679c378d3530b47be.jpg",
    amazonLink: "https://www.amazon.com"
  },
  {
    id: 7,
    name: "Milwaukee M12 Rover Service & Repair Flood Light",
    description: "A magnetic, rechargeable work light that sticks to car hoods or pipes, making it an incredibly useful tool for DIY projects.",
    price: "$79.99",
    image: "https://readdy.ai/api/search-image?query=milwaukee%20m12%20rover%20magnetic%20rechargeable%20work%20light%20on%20a%20clean%20white%20surface%20showcasing%20professional%20tool%20with%20red%20and%20black%20design%20and%20durable%20construction&width=400&height=400&seq=formen007v2&orientation=squarish",
    amazonLink: "https://amzn.to/3YHTmT0"
  },
  {
    id: 8,
    name: "Dr. Squatch Men's Soap Variety Pack",
    description: "Natural, grit-heavy soaps with masculine scents like Pine Tar and Bay Rum that have a massive cult following.",
    price: "$39.99",
    image: "https://readdy.ai/api/search-image?query=dr%20squatch%20natural%20mens%20soap%20bars%20variety%20pack%20with%20rustic%20packaging%20on%20a%20clean%20white%20background%20showcasing%20masculine%20grooming%20products%20with%20organic%20aesthetic%20and%20quality%20ingredients&width=400&height=400&seq=formen008v2&orientation=squarish",
    amazonLink: "https://amzn.to/3ZdQWvk"
  },
  {
    id: 9,
    name: "Mountain Voyage Minimalist Wallet",
    description: "A sleek, RFID-blocking metal wallet with a money clip. It is a popular, affordable alternative to the Ridge wallet.",
    price: "$29.99",
    image: "https://readdy.ai/api/search-image?query=sleek%20minimalist%20metal%20wallet%20with%20money%20clip%20on%20a%20clean%20white%20surface%20showcasing%20modern%20mens%20accessory%20with%20slim%20design%20and%20rfid%20protection%20technology&width=400&height=400&seq=formen009v2&orientation=squarish",
    amazonLink: "https://amzn.to/4pANshf"
  },
  {
    id: 10,
    name: "LEATHERMAN Wave+, 18-in-1 Full-Size Multi-tool",
    description: "Versatile multi-tool for DIY, home, garden, outdoors or everyday carry with 18 essential tools in one compact design.",
    price: "$119.99",
    image: "https://readdy.ai/api/search-image?query=leatherman%20wave%20plus%20multi-tool%20with%20various%20tools%20displayed%20on%20a%20clean%20white%20surface%20showcasing%20professional%20grade%20stainless%20steel%20multi-tool%20with%20durable%20construction%20and%20functionality&width=400&height=400&seq=formen010v2&orientation=squarish",
    amazonLink: "https://amzn.to/3NjtY3v"
  }
];

export default function ForTheMenPage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "For the Men - Men's Gear & Grooming Products",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/for-the-men`,
    "description": "Practical gear, grooming staples, and tools men actually buy. Top-rated men's products including Philips Norelco trimmer, Carhartt beanie, and more.",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": products.map((product, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Product",
          "name": product.name,
          "description": product.description,
          "offers": {
            "@type": "Offer",
            "price": product.price.replace('$', ''),
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": product.amazonLink
          }
        }
      }))
    }
  };

  return (
    <>
      <SEOHead
        title="For the Men - Men's Gear, Grooming & Essential Tools"
        description="Discover practical gear and grooming staples men actually buy including Philips Norelco Trimmer, Carhartt Beanie, Kindle Paperwhite, Bose Speaker, and more. Top-rated men's products."
        keywords="men's gear, men's grooming, men's products, men's essentials, grooming tools, men's accessories, practical gear for men"
        canonicalPath="/for-the-men"
        schemaData={schemaData}
      />
      <div className="min-h-screen w-full animated-gradient px-4 py-12">
        <div className="w-full max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-6 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-2xl"></i>
              <span className="text-lg">Back to Home</span>
            </Link>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
              🫵 For the Men
            </h1>
            <p className="text-white/90 text-lg md:text-xl">
              Practical gear, grooming staples, and tools men actually buy
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {products.map((product) => (
              <div 
                key={product.id}
                className="bg-white/95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 flex flex-col"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{product.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-grow">{product.description}</p>
                  <div className="flex items-center justify-end mt-auto">
                    <a
                      href={product.amazonLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gradient-to-r from-[#8b9b6f] to-[#9bab7f] hover:from-[#7b8b5f] hover:to-[#8b9b6f] text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
                    >
                      <span>View on Amazon</span>
                      <i className="ri-amazon-fill text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="text-center space-y-4">
            <p className="text-white/90 text-sm md:text-base">
              As an Amazon Associate, I earn from qualifying purchases support the hustle 💋
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
